import { type ToastOptions, toastManager } from "./pop-toast"

// 提供API
export const toast = {
	success: (message: string, options?: ToastOptions) => {
		return toastManager.show("success", message, options)
	},

	error: (message: string, options?: ToastOptions) => {
		return toastManager.show("error", message, options)
	},

	warning: (message: string, options?: ToastOptions) => {
		return toastManager.show("warning", message, options)
	},

	info: (message: string, options?: ToastOptions) => {
		return toastManager.show("info", message, options)
	},

	dismiss: (id?: string) => {
		return toastManager.dismiss(id)
	},
}

export default toast
